import { checkDescriptionQuality } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/api/checkDescriptionQuality'
import {
  IDescriptionQualityInitiative,
  IDescriptionQualityResult,
} from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/descriptionQuality/models'

import { KeyInitiative } from 'partner360/entities/keyInitiatives'

import { getEmptyDescriptionQuality } from './validateKeyInitiativeForCopy'

type TDescriptionQualityChecker = (
  initiative: IDescriptionQualityInitiative
) => Promise<IDescriptionQualityResult>

export const getDescriptionQualityForCopy = (
  initiative: KeyInitiative,
  checker: TDescriptionQualityChecker = checkDescriptionQuality
): Promise<IDescriptionQualityResult> => {
  if (!initiative.Description?.trim()) {
    return Promise.resolve(getEmptyDescriptionQuality())
  }

  return checker({
    Name: initiative.Name ?? '',
    Description: initiative.Description,
  })
}
